function darkModeStorage() {
  try {
    return window.localStorage
  } catch (_) {
    return null
  }
}

function darkModeEnabled() {
  return document.documentElement.classList.contains("dark")
}

function setToggleIcon(toggle, enabled) {
  const icon = toggle.querySelector("svg")
  if (!icon) return

  icon.innerHTML = enabled
    ? '<path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z"></path>'
    : '<path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z"></path>'
}

function updateDarkModeToggles() {
  const enabled = darkModeEnabled()
  document.documentElement.dataset.colorModeReady = "true"
  document.querySelectorAll("[data-dark-mode-toggle]").forEach((toggle) => {
    toggle.setAttribute("aria-pressed", enabled ? "true" : "false")
    toggle.setAttribute("aria-label", enabled ? "Switch to light mode" : "Switch to dark mode")
    setToggleIcon(toggle, enabled)
  })
}

function applyStoredDarkMode() {
  document.documentElement.classList.toggle("dark", darkModeStorage()?.getItem("webuild-color-mode") === "dark")
  updateDarkModeToggles()
}

function toggleDarkMode() {
  const enabled = !darkModeEnabled()
  document.documentElement.classList.toggle("dark", enabled)
  darkModeStorage()?.setItem("webuild-color-mode", enabled ? "dark" : "light")
  updateDarkModeToggles()
}

document.addEventListener("click", (event) => {
  const toggle = event.target.closest("[data-dark-mode-toggle]")
  if (!toggle) return

  event.preventDefault()
  event.stopPropagation()
  toggleDarkMode()
}, true)

document.addEventListener("DOMContentLoaded", applyStoredDarkMode)
document.addEventListener("turbo:load", applyStoredDarkMode)

window.WeBuildToggleDarkMode = toggleDarkMode
window.WeBuildUpdateDarkModeToggles = updateDarkModeToggles

applyStoredDarkMode()
